import script from "./success.vue?vue&type=script&setup=true&lang=js"
export * from "./success.vue?vue&type=script&setup=true&lang=js"

import "./success.vue?vue&type=style&index=0&id=2b18dbfe&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b18dbfe"]])

export default __exports__